<template>
    <div id="page" class="page-content">
        <div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
        <div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
        <div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>

        <div class="page-title-small color-white bottom-30">
            <h1><i class="fa fa-arrow-left back-button"></i>Buscar OT</h1>
            <a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"
                v-bind:style="userimageurl"></a>
            <span class="bg-highlight color-white">{{ username }}<br>{{ cargo }}</span>
        </div>

        <div id='content1'>

            <div class="calendar round-small shadow-small">
                <div class="cal-header">
                    <h4 class="cal-title center-text uppercase bolder bg-aqua-light"><a href="#" class="color-white">{{
                            sucursal }}</a></h4>
                </div>
            </div>

            <div class="calendar">
                <div class="search-box search-color bg-aqua-light shadow-tiny round-huge bottom-0">
                    <i class="fa fa-search"></i>
                    <input type="number" v-model="datasearch" @change="buscarOT" placeholder="Buscar por OT"
                        inputmode="numeric" pattern="[0-9]*">
                    <br>
                    <div class="content-boxed"  style="overflow: visible !important; z-index: auto !important;">
                        <a style="width: 100%;" href="#"
                            class="button bg-blue2-dark round-small shadow-small "
                            @click="buscarOT()" data-formId="dataForm">Buscar</a>
                    </div>
                </div>
            </div>

            <div id="menu-email" class="menu menu-box-bottom menu-box-detached round-medium" data-menu-height="290"
                data-menu-effect="menu-over">
                <div id="menu-emailcontent" class="content">
                    <h1 class="uppercase ultrabold top-20">Envío de Trabajos por Email</h1>
                    <form id="formemail">
                        <span id="r_txtemail" style="display:none"
                            class="bg-red2-dark center-text uppercase color-white ultrabold">Requerido</span>
                        <span id="e_txtemail" style="display:none"
                            class="bg-red2-dark center-text uppercase color-white ultrabold">El formato de e-mail es
                            incorrecto</span>
                        <div class="input-style has-icon input-style-1 input-required">
                            <span>Email</span>
                            <em>(requerido)</em>
                            <input id="txtemail" type="email" placeholder="Email">
                        </div>

                        <div class="clear"></div>
                        <a href="#" @click="enviarmailtrabajos()"
                            class="button button-full button-s shadow-large button-round-small bg-blue2-dark top-10">Enviar
                            e-mail</a>
                        <div class="top-20 bottom-20">
                            <a href="#" data-menu="salir" class="center-text font-11 color-gray2-dark">Para cancelar
                                presione aquí</a>
                        </div>
                    </form>

                </div>

                <div id="sendingmail" class="shadow-large alert alert-large alert-round-medium bg-green1-dark"
                    style="display:none">
                    <i class="fa fa-check"></i>
                    <strong class="uppercase ultrabold">Success</strong>
                    <span>Everything's okay here</span>
                    <i data-menu="salir" class="fa fa-times"></i>
                </div>

            </div>

            <div class="content-boxed">
                <div v-for="(a, index) in agenda" class="content">
                    <div class="user-list-slider bottom-0">
                        <div class="user-list-right">
                            <h4 style="top:12px;left:10px">{{ a.FECHAINGRESO }} {{ a.CLIENTEAGENDA }}</h4>
                            <p class="color-aqua-dark" style="font-size:1.5em;top:30px;left:10px">{{
                                a.PLACAPATENTE}}</p>

                            <br>
                            <br>

                            <!-- <a href="#" @click="fechaentrega(a.IN_COD_COTIZACIONVEHICULO)"
                                class="chip chip-small bg-gray1-dark" style="top:25px">
                                <i class="fas fa-calendar-check bg-magenta1-dark"></i>
                                <span class="color-black">Entrega {{ a.FECHAENTREGA}} {{ a.HORAENTREGA}}</span>
                            </a> -->

                            <!-- <a href="#" @click="enviarwhatsapp(a.CLIENTEFONO)" class="chip chip-small bg-gray1-dark"
                                style="top:25px">
                                <i class="fab fa-whatsapp bg-green2-dark"></i>
                                <span class="color-green2-dark">Whatsapp</span>
                            </a> -->

                            <a href="#" @click="VerImagenesOT(a.IN_COD_COTIZACIONVEHICULO)"
                                class="chip chip-small bg-gray1-dark" style="top:25px">
                                <i class="fas fa-image bg-yellow2-dark"></i>
                                <span class="color-black">Imagenes</span>
                            </a>

                            <a href="#" @click="ImprimirOT(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark"
                                style="top:25px">
                                <i class="fa fa-print bg-red2-dark"></i>
                                <span class="color-red2-dark">Imprimir</span>
                            </a>
                            <a href="#" @click="VerOTInterna(a.IDEXTERNO)" class="chip chip-small bg-gray1-dark"
                                style="top:25px">
                                <i class="fa fa-file bg-red3-light"></i>
                                <span class="color-red3-light">Cartón</span>
                            </a>

                            <!-- <a href="#" @click="setdatamail(a.IN_COD_COTIZACIONVEHICULO,a.CLIENTEEMAIL)"
								data-menu="menu-email" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fa fa-envelope bg-blue2-dark">&nbsp; {{ a.NUMEROENVIOSEMAIL }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a>

							<a href="#"
								@click="setdatawhatsapp(a.IN_COD_COTIZACIONVEHICULO,a.IN_COD_USUARIOAGENDA,a.CLIENTEFONO)"
								data-menu="menu-whatsapp" class="chip chip-small bg-gray1-dark" style="top:25px">
								<i class="fab fa-whatsapp bg-green2-dark">&nbsp; {{ a.NUMEROENVIOSWHATSAPP }}</i>
								<span class="color-black">Enviar trabajos</span>
							</a> -->

                            <a href="#" @click="ReciboConformidad(a.IN_COD_COTIZACIONVEHICULO, a.IDEXTERNO)"
                                data-menu="menu-ReciboConformidad" class="chip chip-small bg-gray1-dark"
                                style="top:25px">
                                <i class="fa fa-file bg-blue2-dark"></i>
                                <span class="color-black">Recibo de Conformidad</span>
                            </a>

                            <br>
                            <br>

                        </div>
                    </div>

                    <div class="divider bg-gray2-dark"></div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import * as db from "../../database.js";
    import * as validate from "../../validate.js";

    import VueSignaturePad from 'vue-signature-pad';

export default {

    data() {
        return {
            codsucursal: 0,
            sucursal: "",
            resultadoOT: null,
            agenda: [],
            codusuario: 0,
            datasearch: ''
        };
    },

    created() {
        // Recuperar valores del usuario desde localStorage
        const user = JSON.parse(localStorage.getItem('user')) || {};
        this.username = user.nombre || '';
        this.cargo = user.cargo || '';
        this.sucursal = user.sucursal || '';
        this.codsucursal = user.codsucursal || 0;

        // Formatear la imagen de usuario
        const imageUrl = user.imageurl ? db.getServerHTTP() + user.imageurl : '';
        this.userimageurl = `background-image:url(${imageUrl})`;

        // Recuperar el último valor de búsqueda
        this.datasearch = localStorage.getItem('datasearch') || '';
    },

    methods: {
        async buscarOT() {
            if (!this.datasearch.trim()) {
                this.resultado = null; // Limpia el resultado si no hay búsqueda
                return;
            }

            var OTBuscar = this.datasearch.trim();
            var CodigoSucursaL = this.codsucursal;

            db.getFx2("ot.TraerOT", '{"idcotizacionvehiculo":"' + OTBuscar + '", "idSucursal":"' + CodigoSucursaL + '"}').then(result => {
                console.log(result.data.data);
                this.agenda=result.data.data
            });
        },

        VerImagenesOT(id) {
            localStorage.setItem('idcotizacionvehiculo', id)
            localStorage.setItem('datasearch', this.datasearch);
            window.location = '/ImagenesOT';
        },

        VerOTInterna(id){

            var url = db.getServerHTTP();

            if (url == "http://puente.xxi.cl/") {
                url = "https://xxi.netcar.cl";
            }

            if (url == "http://puente.valenzueladelarze.cl/") {
                url = "http://vyd.netcar.cl";
            }

            window.open(url + "/taller/tlrShowOTInterna.aspx?id=" + id + "&file=" + this.idFile + "'", "_blank");
        },

        ImprimirOT(id){

            var url = db.getServerHTTP();

            if (url == "http://puente.xxi.cl/") {
                url = "https://xxi.netcar.cl";
            }

            if (url == "http://puente.valenzueladelarze.cl/") {
                url = "http://vyd.netcar.cl";
            }

            window.open(url + "/taller/tlrShowOT2.aspx?id=" + id + "&file=" + this.idFile + "'", "_blank");

        },

        ReciboConformidad(id, idExterno) {
            localStorage.setItem('idcotizacionvehiculoReciboConformidad', id);
            localStorage.setItem('idExternoReciboConformidad', idExterno);
            localStorage.setItem('datasearch', this.datasearch);
            localStorage.setItem('PaginaVolver', "/BuscarOT");
            window.location = "/ReciboConformidad"
        },

    }
}

</script>